import { getBlob } from '../components/hooks/apiFetch';

export const loadFileData = async (identifier, fileNames, extensionMap = {}, defaultOutputFormat = 'txt') => {
    const filesData = await Promise.all(
        fileNames.map(async (fileName) => {
            const url = `/api/OperationInfo/File/${encodeURIComponent(identifier)}?fileName=${encodeURIComponent(fileName)}&isOriginalFile=${encodeURIComponent(true)}&isSuccessFinished=${encodeURIComponent(false)}`;
            const blob = await getBlob(url);
            const fileNameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.')) || fileName;
            const outputFormat = extensionMap[fileNameWithoutExt] || defaultOutputFormat;

            return {
                file: new File([blob], fileName, { type: blob.type }),
                outputFormat,
            };
        })
    );
    return filesData;
};